import { render, staticRenderFns } from "./supplierInfo.vue?vue&type=template&id=66833cde&scoped=true&"
import script from "./supplierInfo.vue?vue&type=script&lang=js&"
export * from "./supplierInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66833cde",
  null
  
)

export default component.exports